import { types as actions } from '../actions';

const defaultState = {
  notification: "",
  error: {
    message: ""
  }
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.ADD_INFO:
      return {
        ...state,
        notification: action.payload
      };
    case actions.REMOVE_INFO:
      return {
        ...state,
        notification: ""
      }
    case actions.ERROR:
      const errorMessage = action.payload.response && action.payload.response.message ?
        action.payload.response.message : 'Something went wrong!';
      return {
        ...state,
        error: { message: errorMessage }
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/notifications/index.js